import React from 'react'

import OnlineStatus from '../_online_status'

const OnlineStatusNoBorder = (props) => (
  <>
    <OnlineStatus
        noBorder
        {...props}
    />
  </>
)

export default OnlineStatusNoBorder
